module.exports = __webpack_public_path__ + "img/instagram.7e2e5aef.png";